import appIcon from "@/assets/app-icon.png";

export default function AccountConfirmation() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-6">
      <img src={appIcon} alt="Jobily" className="w-16 h-16 rounded-2xl mb-6" />
      <h1 className="font-display font-bold text-xl text-foreground">Account Confirmed</h1>
      <p className="text-sm text-muted-foreground mt-2">Please return to the app and login</p>
    </div>
  );
}
